import { normalizeMap } from '../lib'
import windowDataProp from './windowDataProp'

export default function (props) {
  const res = {}
  normalizeMap(props).forEach(({key, val}) => {
    res[key] = windowDataProp(key, val)
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/mapWindowData.js